import { Element } from "../../../Interface/scheduler/form";

const TextField = ({ element }: { element: Element }) => {
  return (
    <div className={element.type} key={element.type}>
      <p>{element.content}</p>
    </div>
  );
};

export default TextField;
